var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.913,
    height: 56.292,
    viewBox: "0 0 55.913 56.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13295",
    "data-name": "Group 13295",
    transform: "translate(-931.203 -219.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M20.826,0A20.826,20.826,0,1,1,0,20.826",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 984.666, 233.475)",
    fill: "none",
    stroke: "#21d17f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M1503.978-13726h-30.8v-13.516",
    transform: "translate(9623.939 11001.472) rotate(-45)",
    fill: "none",
    stroke: "#21d17f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.20b4c33db1c6304742d031e506a15886.svg";
export { ForwardRef as ReactComponent };